import { categoryNameToSlug, categoryToUri, ResourceCategory, sortResourceCategoriesByNameFn, subcategoryToUri } from '@core';
import { mc, StyleProps } from '@styles';
import { scrollToTop } from '@utils';
import React, { FC, Fragment } from 'react';

import { getResourceCategoryIcon } from '../utils';

interface Props extends StyleProps {
  rootCategory?: ResourceCategory;
  items: ResourceCategory[];
  color?: 'white' | 'seafoam';
  linkType?: 'anchor' | 'link';
  active?: ResourceCategory;
}

export const ResourceСategoriesMenu: FC<Props> = ({
  className,
  style,
  rootCategory,
  items,
  active,
  color = 'white',
  linkType = 'anchor',
}) => {
  const isHighlighted = (itm: ResourceCategory) => itm.id === active?.id;

  const getItemUrl = (itm: ResourceCategory): string => {
    if (linkType === 'anchor') {
      return `#${categoryNameToSlug(itm.name)}`;
    }
    return rootCategory ? subcategoryToUri(rootCategory, itm) : categoryToUri(itm);
  };

  const renderSeparator = () => (
    <div className={mc('w-[1px] my-2 hidden sm:block', color === 'white' && 'bg-seafoam', color === 'seafoam' && 'bg-white')} />
  );

  return (
    <div
      className={mc(
        'px-[10px] sm:px-2 py-0 sm:py-3',
        'shadow rounded-xl',
        color === 'white' && 'bg-white',
        color === 'seafoam' && 'bg-seafoam',
        'flex flex-row flex-wrap justify-center items-stretch',
        className,
      )}
      style={style}
    >
      {items.sort(sortResourceCategoriesByNameFn).map((itm, index) => (
        <Fragment key={itm.name}>
          {index > 0 && renderSeparator()}
          <a
            className={mc(
              'flex flex-col justify-center sm:justify-start items-center',
              'w-[110px] sm:w-[150px] py-2 px-2 mx-0 sm:mx-1',
              ' hover:stroke-accent-orange hover:text-accent-orange',
              isHighlighted(itm) ? 'stroke-accent-orange text-accent-orange' : 'stroke-ocean-blue text-ocean-blue',
            )}
            href={getItemUrl(itm)}
            onClick={scrollToTop}
          >
            <span className="w-[45px] h-[45px] sm:h-[64px] sm:w-[64px] flex justify-center items-center">
              {getResourceCategoryIcon(itm, rootCategory)}
            </span>
            <span className="block text-center text-base font-roboto leading-normal">{itm.name}</span>
          </a>
        </Fragment>
      ))}
    </div>
  );
};

export type ResourceСategoriesMenuProps = Props;
export default ResourceСategoriesMenu;
